import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button, Container, Paper, TextField, Typography } from '@material-ui/core';
import { RequestStatus, stores } from 'mobx-store/index';
import { observer } from 'mobx-react';
import SnackBarComponent from 'components/SnackBarComponent/SnackBarComponent';
import { useHistory } from 'react-router';

const UserDeleteRequestScreen = observer(() => {
  const history = useHistory();
  const { search, pathname } = history.location;
  const queryParams = new URLSearchParams(search);
  const { userDeletionRequestStore } = stores;
  const formik = useFormik({
    initialValues: {
      membershipId: '',
      phoneNumber: '',
    },
    validationSchema: Yup.object({
      membershipId: Yup.string()
        .matches(/^\d+_\d+$/, 'Membership ID must be in the format "numbers_numbers" (e.g., 00200_8)')
        .required('Membership ID is required'),
      phoneNumber: Yup.string()
        .matches(/^0[0-9]{10}$/, 'Phone number must start with 0 and be 11 digits long')
        .required('Phone number is required'),
    }),
    onSubmit: async (values, { resetForm }) => {
      const { membershipId, phoneNumber } = values;
      await userDeletionRequestStore.createUserDeletionRequest(membershipId, phoneNumber);
      if (userDeletionRequestStore.status === RequestStatus.SUCCESS) {
        SnackBarComponent.getInstance().openSnackbar('Saved sucussfully', 8000, 'success');
        queryParams.set('success', 'true');
        history.push(`${pathname}?${queryParams.toString()}`);
        resetForm();
      } else if (userDeletionRequestStore.status === RequestStatus.FAILED) {
        queryParams.set('success', 'false');
        history.push(`${pathname}?${queryParams.toString()}`);
        SnackBarComponent.getInstance().openSnackbar(userDeletionRequestStore.error, 8000, 'error');
      }
    },
  });

  return (
    <Container component="main" maxWidth="xs">
      <Paper elevation={3} style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img src="https://upload.wikimedia.org/wikipedia/ar/0/08/Wadi_Degla_Logo.png" alt="Logo" style={{ marginBottom: '20px', maxHeight: 140 }} />

        <Typography variant="h6" gutterBottom>
          Request Delete User Form
        </Typography>
        <form onSubmit={formik.handleSubmit} style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <TextField
            fullWidth
            id="membershipId"
            name="membershipId"
            label="Membership ID"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.membershipId}
            error={formik.touched.membershipId && Boolean(formik.errors.membershipId)}
            helperText={formik.touched.membershipId && formik.errors.membershipId}
            margin="normal"
          />

          <TextField
            fullWidth
            id="phoneNumber"
            name="phoneNumber"
            label="Phone Number"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.phoneNumber}
            error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
            helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
            margin="normal"
          />

          <Typography variant="body2" color="textSecondary" paragraph align='center'>
            Your delete account request will be processed as soon as possible. Our customer service will reach out to verify
            your request.
          </Typography>

          <Button type="submit" variant="contained" color='primary' style={{ width: 300, textAlign: 'center' }}>
            {userDeletionRequestStore.status === RequestStatus.LOADING ?
              'Submitting...' :
              'Delete Account Request'}
          </Button>
        </form>
      </Paper>
    </Container >
  );
});

export default UserDeleteRequestScreen;